module.exports = __webpack_public_path__ + "img/ic_services_cafeteria.b1b591cb.svg";